import React from 'react';
import './HeroMessage.css'



const HeroMessage = ()  => {


    return (
    <div className="hero-message-container">
        <h4 className="sub-slogan  "> Refulgence <em style={{ fontWeight:"lighter", fontSize:"13px"}}> noun</em> </h4>
       <h1 className="slogan  animate__animated animate__fadeIn"> : a radiant or resplendent quality or state : <em class="brilliance">BRILLIANCE</em></h1>
    </div>
    )



}







export default HeroMessage;